var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecordingNotification = function SvgRecordingNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.057 0 0 8.057 0 18a17.966 17.966 0 0 0 6.073 13.486A17.974 17.974 0 0 0 18 36c4.578 0 8.752-1.708 11.927-4.521A17.94 17.94 0 0 0 36 18c0-9.943-8.058-18-18-18Z",
    fill: "url(#recording-notification_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.561 24C9.908 24 9 23.152 9 21.594v-7.188C9 12.848 9.924 12 11.561 12h8.56c1.638 0 2.53.848 2.53 2.406v7.188c0 1.558-.909 2.406-2.546 2.406H11.56Zm11.932-3.84v-4.32l2.87-2.205c.275-.2.535-.355.826-.355.47 0 .811.34.811.88v7.68c0 .556-.34.88-.81.88-.292 0-.552-.139-.827-.355l-2.87-2.206Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recording-notification_svg__a",
    x1: 0.998,
    y1: 1.996,
    x2: 0.998,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5F62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9356F"
  })))));
};
export default SvgRecordingNotification;